import { map, omit } from 'lodash';

export function useTranformSelectElement() {
  const removeDOM = (obj) => omit(obj, ['key', 'value', 'label']);
  const addDOM = (obj) => map(obj, (ss) => ({ ...ss, value: ss?.id, label: ss?.label_en }));

  return {
    removeDOM,
    addDOM,
  };
}
